import { useMantineTheme } from '@mantine/core';

import { CurrencyConvertor } from '~/components/utils/formatters';
import { Text } from '~/domains/design-system/Text';

function ContestEntryFeeColumn({ entry_fee }: { entry_fee: number }) {
  const theme = useMantineTheme();

  return <Text
    variant="body-medium"
    color={theme.colors.gray[8]}
  >
    {CurrencyConvertor(entry_fee / 100)}
  </Text>
}

export default ContestEntryFeeColumn;
